module.exports = __webpack_public_path__ + "img/services-background-01.e33073b5.jpg";